
<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">商店入口一覽</h4>
              </div>
              <div class="card-body">
                <!-- <router-link to="./gaa-users/new" type="success">
                  <n-button type="success">建立 GAA 管理員</n-button>
                </router-link>-->
                <p>一覽各個商店上架情況</p>
                <el-row :gutter="20">
                  
                  <el-col :xs="12" :md="3">
                    <router-link to="../portals" type="success">
                      <el-button type="warning" size="small">返回入口列表</el-button>
                    </router-link>
                  </el-col>
                
                  <el-col :xs="24" :md="6">
                    <el-input
                      v-model="filters[0].value"
                      placeholder="搜尋店家"
                      size="small"
                      prefix-icon="el-icon-search"
                    ></el-input>
                  </el-col>
                </el-row>

                <data-tables :data="data" :filters="filters" >
                <!-- <data-tables :data="data" :filters="filters" :action-col="actionCol"> -->
                  <!-- <el-table-column label="ID" prop="id" sortable="custom" min-width="50px">
                    <template slot-scope="scope">{{scope.row.id}}</template>
                  </el-table-column> -->
                  <el-table-column
                    v-for="title in titles"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.prop"
                    sortable="custom"
                  ></el-table-column>
                </data-tables>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      data: [],
      titles: [
        {
          prop: "id",
          label: "NO."
        },
        {
          prop: "name",
          label: "名稱"
        },
        {
          prop: "portals",
          label: "上架入口"
        },
        // {
        //   prop: "endAt",
        //   label: "結束時間"
        // },
        // {
        //   prop: "updatedAt",
        //   label: "更新時間"
        // }
      ],
      actionCol: {
        label: "操作",
        props: {
          align: "center",
          width: "300"
        },
        buttons: [
          {
            props: {
              type: "success",
              size: "small",
              icon: "el-icon-s-marketing"
            },
            label: "商店",
            handler: row => {
              this.$router.push(`/portals/${row.id}/shops`);
            }
          },
          {
            props: {
              type: "warning",
              size: "small",
              icon: "el-icon-setting"
            },
            label: "設定",
            handler: row => {
              this.$router.push(`/portals/${row.id}/edit`);
            }
          }
        ]
      },
      filters: [
        {
          value: "",
          prop: ["name", "id"]
        },
        {
          value: []
        }
      ]
    };
  },
  methods: {
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    getPortalShops() {
      return axios
        .get(`${process.env.VUE_APP_APIHOST}/gaa/portal-shops`)
        .then(response => {
          this.data = response.data;
          
          return response.data;
        });
    }
  },
  mounted() {
    this.getPortalShops();
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
</style>